import { EProductCardLabelType, IProductCardInfoLabel } from '@pu/mpp-ui/components/product-card';
import { ExclusivePromoLabel } from './exclusive-promo-label';

export const EXCLUSIVE_PROMO_LABEL: IProductCardInfoLabel = {
  content: <ExclusivePromoLabel />,
  type: EProductCardLabelType.BRAND,
};
